export enum DataSchemaDataDefinitionDataType {
  ArrayStorage = 'array-storage'
}
